"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountBalanceLoadingState = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var asg_1 = require("@alinta-digital/asg");
var SkeletonWrapper_1 = require("../../SkeletonWrapper");
var AccountBalanceLoadingState = function () {
    return (react_1.default.createElement(asg_1.Box, { margin: { bottom: 'xsmall' }, width: "100%", "data-testid": "accountBalanceSkeleton" },
        react_1.default.createElement(SkeletonWrapper_1.SkeletonWrapper, { baseColor: asg_1.colors['grey-2'], height: 88, width: '100%', count: 1, style: { borderRadius: '0px', zIndex: 'inherit' } })));
};
exports.AccountBalanceLoadingState = AccountBalanceLoadingState;
//# sourceMappingURL=AccountBalance.loading.js.map